<template>
  <ny-main title="Infinities 广告主平台" platform="ad-user" :route-data="routeData"></ny-main>
</template>

<script>
import NyMain from '@/global/views/Main'
import { routeData } from '../router'

export default {
  name: 'Main',
  components: {
    NyMain
  },
  data () {
    return {
      routeData
    }
  }
}
</script>
